import {Component} from '@angular/core';
import {CapiLoginService} from 'app/core/extension/login/capi-login-service';
import {keysToTranslate} from 'i18n/keys-to-translate';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'cap-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent {

  title: string;

  constructor(private loginService: CapiLoginService,
              private translateService: TranslateService) {
    keysToTranslate<string>([
      'layouts.notAutorizedTitle'
    ]);
    this.title = this.translateService.instant('layouts.notAutorizedTitle', {appTitle: this.getAppTitle()});
  }

  getAppTitle(): string {
    return this.translateService.instant('layouts.page.title');
  }

  logoutAndRedirect() {
    this.loginService.logout();
  }
}
